var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert",class:{ show: _vm.alert.message }},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.alert.message))]),_c('button',{staticClass:"close",on:{"click":_vm.close}},[_vm._v("×")])])
}
var staticRenderFns = []

export { render, staticRenderFns }